import { create } from "zustand";

const initialState = {
  showModal: false,
};

const useQualificationModalStore = create((set) => ({
  ...initialState,
  toggleModal: () => {
    set((state) => ({ showModal: !state.showModal }));
  },
  setShow: (payload) => {
    set({ showModal: payload });
  },
}));

export default useQualificationModalStore;
